<div id="wire-credit-to-fields-container">
  <div id="credit-to-header" *ngIf="!useSloa || (useSloa && !isISOCompliant)">Second intermediary details</div>
  <div id="credit-to-inputs-container" *ngIf="!useSloa || (useSloa && !isISOCompliant)" data-testid="credit-to-selection">
    <div class="row">
      <!-- Institution account number -->
      <mm-text-input-control class="input-box" [parentForm]="parentForm" [inputControlModel]="accountNumberModel">
      </mm-text-input-control>
      <!-- Institution phone (optional) -->
      <mm-text-input-control class="input-box" [parentForm]="parentForm" [inputControlModel]="phoneModel">
      </mm-text-input-control>
    </div>
    <span id="credit-to-name-address-header">{{creditToNameHeader}}</span>
    <div class="row">
      <!-- Institution name -->
      <mm-text-input-control class="input-box" [parentForm]="parentForm" [inputControlModel]="nameModel">
      </mm-text-input-control>
      <!-- Institution name continued (optional) -->
      <mm-text-input-control class="input-box" [parentForm]="parentForm" [inputControlModel]="nameContdModel">
      </mm-text-input-control>
      <!-- Institution country -->
      <div id="credit-to-country-display">
        <label id="credit-to-country-label">Intermediary country</label>
        <span id="wires-credit-to-country" data-testid="institutionCountry-span" class="country">{{institutionCountry.value}}</span>
      </div>
    </div>
    <div id="address-country-container" class="end-row input-box">
      <!-- Institution address-->
      <mm-text-input-control class="input-box" id="credit-to-address-first-line" [parentForm]="parentForm" [inputControlModel]="addressModel">
      </mm-text-input-control>
      <!-- Institution address continued (optional) -->
      <mm-text-input-control class="input-box" [parentForm]="parentForm" [inputControlModel]="addressContdModel">
      </mm-text-input-control>
    </div>
  </div>
  <div id="credit-to-inputs-container" *ngIf="(useSloa && isISOCompliant)" data-testid="credit-to-selection" class="table mt-16">
    <span id="credit-to-name-address-header" class="ft-16">{{creditToNameHeader}}</span>
    <div class="medium-bottom-spacer">
      <div id="resp-table">
        <div id="resp-table-body">
          <div class="resp-table-row">
            <span class="table-body-cell schwab-grey" *ngIf="secondIntermediaryAccountNumber">
              {{secondIntermediaryUseSloaAccountNumberHeader}}
            </span>
            <span class="table-body-cell schwab-grey" *ngIf="secondIntermediaryBIC">
              Business ID code (BIC)
            </span>
            <span class="table-body-cell schwab-grey" *ngIf="secondIntermediaryClearingSysId">
              Clearing system ID
            </span>
            <span class="table-body-cell schwab-grey">
              Bank information
            </span>
          </div>
          <div class="resp-table-row">
            <span class="table-body-cell" *ngIf="secondIntermediaryAccountNumber">
              {{secondIntermediaryAccountNumber}}
            </span>
            <span class="table-body-cell" *ngIf="secondIntermediaryBIC">
              {{secondIntermediaryBIC}}
            </span>
            <span class="table-body-cell" *ngIf="secondIntermediaryClearingSysId">
              {{secondIntermediaryClearingSysId}}
            </span>
            <span class="table-body-cell" style="white-space: pre-line;">
              {{secondIntermediaryUseSloaAddress}}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
